interface Brand {
  id: number;
  name: string;
  logo: string;
  displayName: string;
  position: number | null;
  color: string | null;
  marketIds: number[];
  reputationMarketIds?: number[];
}
export const prepareBrandData = (group: any, brandsLookup: any): Brand[] => {
  const brandsData: any = group?.brands || [];
  const brandLookups = (brandsLookup || {}) as {
    [key: string]: {
      id: number;
      name: string;
      displayName: string;
      logo: string;
      color: string;
    };
  };

  return brandsData.map((brand: any) => {
    const lookup = brandLookups[String(brand.brandId)];
    const reputationMarketIds =
      brand.markets
        ?.filter((market: any) => market?.reputationDataAvailable === true)
        ?.map((market: any) => market.marketId) || [];

    return {
      id: brand.brandId,
      name: brand?.brandDisplayName || brand?.brandName,      
      logo: lookup?.logo || "",
      displayName: brand.brandDisplayName || brand.brandName,
      position: brand.order,
      color: brand.color,
      marketIds: brand.markets.map((market: any) => market.marketId),
      reputationMarketIds,
    };
  });
};

export const prepareBrandsMappingData = (brandsOrderMapping: any) => {
  const result: Record<string, number[]> = {};
  brandsOrderMapping?.forEach((value: any) => {
    if (value?.marketId) {
      result[value.marketId] = value?.orderedBrandIds;
    }
  });
  return result;
};

export const prepareMarketData = (markets: any, marketLookup: any): any => {
  const brandMarketLookup = markets?.reduce((acc: any, curr: any) => {
    return {
      ...acc,
      [curr.marketId]: curr,
    };
  }, {});
  const result: any = [];
  Object.values(marketLookup)?.forEach((market: any) => {
    result.push({
      id: market?.id,
      name: market?.displayName || market?.name,
      region: market?.region,
      identity: market?.code,
      activeContractsCount: 0,
      position: brandMarketLookup?.[market?.id]?.order,
      color: market?.color,
      groupName:
        market?.region === "International" ? market?.region : market?.name,
    });
  });

  const marketGroup = result?.reduce((acc: any, curr: any) => {
    if (acc[curr?.groupName]) {
      return {
        ...acc,
        [curr.groupName]: {
          ...acc[curr.groupName],
          marketIds: [...acc[curr?.groupName]?.marketIds, curr?.id],
        },
      };
    }
    return {
      ...acc,
      [curr.groupName]: {
        id: curr?.groupName,
        name: curr?.groupName,
        marketIds: [curr?.id],
      },
    };
  }, {});

  const groupList = Object.values(marketGroup).sort((a: any, b: any) =>
    a.name.localeCompare(b.name),
  );

  return {
    markets: result,
    groups: groupList,
  };
};

export function prepareFeatureStatusData(currData: any) {
  const result: any = {};

  currData?.modules?.map((module: any) => {
    if (module?.key) {
      if (module?.enabled) {
        result[module.key === "brand-visibility" ? "visibility" : module.key] =
          {
            bysegment: true,
            bybrand: true,
            bymarket: true,
          };
      } else {
        result[module.key === "brand-visibility" ? "visibility" : module.key] =
          {
            bysegment: false,
            bybrand: false,
            bymarket: false,
          };
      }
    }
  });

  const reportBuilder = currData?.features?.find(
    (feature: any) => feature?.key === "report.builder",
  );
  const exclusiveQuestions = currData?.features?.find(
    (feature: any) => feature?.key === "exclusive.questions",
  );
  const legacyScore = currData?.features?.find(
    (feature: any) => feature?.key === "rq.scoreType.legacyScore",
  );
  const meanScore = currData?.features?.find(
    (feature: any) => feature?.key === "rq.scoreType.meanScore",
  );
  const aiAssistant = currData?.features?.find(
    (feature: any) => feature?.key === "ai.assistant",
  );

  if (reportBuilder && reportBuilder?.enabled) {
    result["reports"] = {
      enabled: true,
    };
  } else {
    result["reports"] = {
      enabled: false,
    };
  }

  if (exclusiveQuestions && exclusiveQuestions?.enabled) {
    result["exclusivequestions"] = {
      bybrand: true,
      bysegment: true,
    };
  }

  if (legacyScore && legacyScore?.enabled) {
    result["legacyScore"] = {
      enabled: true,
    };
  } else {
    result["legacyScore"] = {
      enabled: false,
    };
  }

  if (meanScore && meanScore?.enabled) {
    result["meanScore"] = {
      enabled: true,
    };
  } else {
    result["meanScore"] = {
      enabled: false,
    };
  }

  if (aiAssistant && aiAssistant?.enabled) {
    result["aiAssistant"] = {
      enabled: true,
    };
  } else {
    result["aiAssistant"] = {
      enabled: false,
    };
  }
  
  return result;
}
